<ng-container>
  <!-- Select with autocomplete -->
  <mat-form-field [ngClass]="formFieldClass" data-testid="select-autocomplete" *ngIf="enableTypeahead; else selectMode">
    <mat-label *ngIf="!(noFloatingLabel && control.value)" data-testid="label">{{ label }}</mat-label>
    <mat-icon matPrefix *ngIf="!ionicIcons && optionTemplateName !== 'site-icon'; else siteIconPrefix">search</mat-icon>
    <ion-icon matPrefix *ngIf="ionicIcons" name="search"></ion-icon>

    <ng-template #siteIconPrefix>
      <ng-container *ngIf="!ionicIcons">
        <mat-icon matPrefix *ngIf="!control.value; else iconPrefix">search</mat-icon>
        <ng-template #iconPrefix>
          <app-site-icon-and-name
            matPrefix
            class="site-icon-label"
            [item]="itemsMap.get(control.value)"></app-site-icon-and-name>
        </ng-template>
      </ng-container>
    </ng-template>
    <input
      data-testid="search-typeahead"
      type="text"
      matInput
      [formControl]="$any(control)"
      [matAutocomplete]="auto"
      (openedChange)="openedChange($any($event))" />
    <mat-icon
      *ngIf="control.enabled && !ionicIcons && control.value"
      data-testid="clear-typeahead"
      (click)="control.reset()"
      class="pointer"
      matSuffix>
      close
    </mat-icon>
    <ion-icon
      *ngIf="control.enabled && ionicIcons && control.value"
      name="close"
      matSuffix
      (click)="control.reset()"
      class="pointer"></ion-icon>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let item of filteredOptions | async" [value]="item.id">
        <ng-container *ngTemplateOutlet="templateRef; context: { item: item }"></ng-container>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!-- Multiple select -->
  <ng-template #selectMode>
    <mat-form-field
      *ngIf="multiple; else simpleSelect"
      [ngClass]="formFieldClass"
      [class.has-values]="keysSelectedSet.size"
      [appearance]="appearance || 'fill'"
      [class.shrink]="appearance === 'outline'">
      <mat-label *ngIf="!(multiple && noFloatingLabel && keysSelectedSet.size)" data-testid="label">
        {{ label }}
      </mat-label>
      <mat-select
        [disableOptionCentering]="true"
        [panelClass]="panelClass"
        data-testid="select-complex"
        [multiple]="true"
        [disabled]="control.disabled"
        [ngModel]="keysSelected"
        (openedChange)="openedChange($event)">
        <div class="trigger-all-wrapper">
          <div>
            <button
              mat-raised-button
              data-testid="select-all"
              (click)="selectAll()"
              translate="selector/select-all"></button>
            <button
              mat-raised-button
              data-testid="unselect-all"
              (click)="unselectAll()"
              translate="selector/unselect-all"></button>
          </div>
          <mat-form-field data-testid="select-autocomplete" *ngIf="!disableMultipleTypeahead">
            <mat-icon matPrefix>search</mat-icon>
            <input
              data-testid="search-typeahead"
              type="text"
              matInput
              [formControl]="searchControl"
              (keydown)="$event.stopPropagation()"
              (openedChange)="openedChange($any($event))" />
            <mat-icon
              *ngIf="searchControl.value"
              data-testid="clear-typeahead"
              (click)="searchControl.reset()"
              class="pointer"
              matSuffix
              >close</mat-icon
            >
          </mat-form-field>
        </div>
        <mat-select-trigger *ngIf="itemsSelectedPreview?.length">
          <ng-container *ngFor="let item of itemsSelectedPreview; last as last">
            <ng-container *ngTemplateOutlet="templateRef; context: { item: item }"></ng-container
            ><span *ngIf="!last">,&nbsp;</span>
          </ng-container>
        </mat-select-trigger>
        <mat-option
          *ngFor="let item of filteredOptions | async"
          [value]="item[identifier]"
          [disabled]="item.disabled"
          (onSelectionChange)="selectItem($event)">
          <ng-container *ngTemplateOutlet="templateRef; context: { item: item }"></ng-container>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>

  <!-- Simple select -->
  <ng-template #simpleSelect>
    <mat-form-field
      [ngClass]="formFieldClass"
      [class.has-value]="control.value"
      [appearance]="appearance || 'fill'"
      [class.shrink]="appearance === 'outline'">
      <mat-label data-testid="label"> {{ label }} </mat-label>
      <mat-select
        data-testid="select-simple"
        [formControl]="$any(control)"
        (openedChange)="openedChange($event)"
        [panelClass]="panelClass">
        <mat-select-trigger *ngIf="itemsSelectedPreview && itemsSelectedPreview[0]">
          <ng-container *ngTemplateOutlet="templateRef; context: { item: itemsSelectedPreview[0] }"></ng-container>
        </mat-select-trigger>
        <mat-option *ngIf="showEmptyOption" [value]=""></mat-option>
        <mat-option *ngFor="let item of items" [value]="item[identifier]" [disabled]="item.disabled">
          <ng-container *ngTemplateOutlet="templateRef; context: { item: item }"></ng-container>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>
</ng-container>

<!-- This is the default template used to display an option -->
<ng-template #iconClassAndText let-item="item">
  <span *ngIf="item.iconClass" [ngClass]="item.iconClass"></span>
  {{ item.label }}
</ng-template>

<!-- 
  This is a template to display an option as a site or a site group option.
  It means with an icon as a png and the site label.
 -->
<ng-template #siteIconAndText let-item="item">
  <app-site-icon-and-name [item]="item">
    {{ item.label }}
  </app-site-icon-and-name>
</ng-template>
